import apiInstance from "./api";

export type PrizeType = "round" | "season";

export interface PrizeImage {
	url: string;
	key: string;
}

export interface PrizeLeagueRef {
	_id: string;
	name?: string;
	sport?: string;
	series?: string;
	season?: string;
}

export interface PrizeEventRef {
	_id: string;
	name?: string;
	date?: string;
	round?: number;
}

export interface PrizeWinnerSnapshotRef {
	_id: string;
	name?: string;
	dateCreated?: string;
}

export interface PrizeRecord {
	_id: string;
	league: string | PrizeLeagueRef;
	prizeType: PrizeType;
	event: string | PrizeEventRef | null;
	sport: string;
	series: string;
	season: string | null;
	title: string;
	description: string;
	linkUrl: string;
	image: PrizeImage;
	winnerSnapshot: string | PrizeWinnerSnapshotRef | null;
	winnerLabel: string;
	isActive: boolean;
	createdAt: string;
	updatedAt: string;
}

export interface PrizeListResponse {
	items: PrizeRecord[];
	total: number;
	page: number;
	limit: number;
}

export interface PrizePayload {
	league: string;
	prizeType: PrizeType;
	event?: string | null;
	title: string;
	description: string;
	linkUrl?: string;
	image?: PrizeImage;
	winnerSnapshot?: string | null;
	winnerLabel?: string;
	isActive?: boolean;
}

export const getPublicPrizes = async (params?: {
	page?: number;
	limit?: number;
	leagueId?: string;
	prizeType?: PrizeType;
	sport?: string;
	series?: string;
	season?: string;
	event?: string;
}) => apiInstance.get<PrizeListResponse>("/prizes/public", { params });

export const getManageablePrizes = async (params?: {
	page?: number;
	limit?: number;
	leagueId?: string;
	prizeType?: PrizeType;
	active?: boolean;
	q?: string;
}) =>
	apiInstance.get<PrizeListResponse>("/prizes/manage", {
		params: {
			...params,
			active:
				typeof params?.active === "boolean" ? String(params.active) : undefined,
		},
	});

export const createPrize = async (payload: PrizePayload) =>
	apiInstance.post<PrizeRecord>("/prizes", payload);

export const updatePrize = async (prizeId: string, payload: PrizePayload) =>
	apiInstance.put<PrizeRecord>(`/prizes/${prizeId}`, payload);

export const deletePrize = async (prizeId: string) =>
	apiInstance.delete<{ success: boolean }>(`/prizes/${prizeId}`);

export const uploadPrizeImage = async (file: File, leagueId: string) => {
	const formData = new FormData();
	formData.append("image", file);
	formData.append("leagueId", leagueId);
	return apiInstance.post<{ url: string; key: string }>(
		"/prizes/upload-image",
		formData,
	);
};
